import React from "react";

import "./burger.scss";

export const Burger = ({ className, open, onClick }) => {
	return (
		<div className='burger-wrapper'>
			<div
				onClick={onClick}
				className={[`burger`, `burger--${open ? `is-open` : `not-open`}`, className].join(` `)}>
				<div className={`burger-line`}></div>
				<div className={`burger-line`}></div>
				<div className={`burger-line`}></div>
			</div>
		</div>
	);
};
